import React, { useEffect, useState } from 'react';
import { addDoc, collection, doc, getDocs, orderBy, query, setDoc } from "firebase/firestore";
import { db } from '../../../../firebase';
import statesCities from "../../../../assets/json/states-and-districts.json";
import countries from "../../../../assets/json/all-countries.json";
import { useAuth } from '../../../../context/AuthContext';
import { Button, Offcanvas, Spinner } from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';
import LeadForm from '../../../leads/form';
import { toast } from 'react-toastify';

function AddNewLead({ showModal, setShowModal }) {

  const { user, settings } = useAuth();
  const { bid } = user.claims;

  const [isLoading, setIsLoading] = useState(false);
  const [cities, setCities] = useState(null);
  const [properties, setProperties] = useState(null);
  const [data, setData] = useState({
    status: "New",
    source: "",
    visibility: "Private",
    assignedTo: "",
    name: "",
    type: "Person",
    phoneNumber: "",
    altPhoneNumber: "",
    email: "",
    address: "",
    city: "",
    state: "",
    interestedProject: null,
    budgetRange: "",
    propertyType: "",
    timeline: "Immediately",
    createdBy: user?.uid || "-"
  });
  const [noteData, setNoteData] = useState({
    title: "",
    note: "",
    attachments: null,
    type: "notes",
    createdBy: user?.uid || ""
  });
  const [inputError, setInputError] = useState(null);

  const resetForm = () => {
    setData({
      status: "New",
      source: "",
      visibility: "Private",
      assignedTo: "",
      name: "",
      type: "Person",
      phoneNumber: "",
      altPhoneNumber: "",
      email: "",
      address: "",
      city: "",
      state: "",
      interestedProject: null,
      budgetRange: "",
      propertyType: "",
      timeline: "Immediately",
      createdBy: user?.uid || "-"
    });

    setNoteData({
      title: "",
      note: "",
      attachments: null,
      type: "notes",
      createdBy: user?.uid || ""
    })
  }

  function getCityByState(state) {
    const filteredCitiesByState = statesCities && statesCities.find(val => val.state === state).districts;

    if (filteredCitiesByState) {
      const tempCities = [];
      for (let i = 0; i < filteredCitiesByState.length; i++) {
        tempCities.push({ name: filteredCitiesByState[i] });
      }

      setCities(tempCities);
    }
  }

  async function getProperties() {
    const q = query(collection(db, "Businesses", bid, "Properties"), orderBy('name'));
    const querySnapshot = await getDocs(q);
    const tempData = [];
    querySnapshot.forEach((doc) => {
      tempData.push({ id: doc.id, ...doc.data() });
    });

    setProperties(tempData);
  }

  useEffect(() => {
    if (settings) {
      settings.forEach(doc => {
        if (doc.id === 'general') {
          setData((prevData) => {
            return {
              ...prevData,
              propertyType: doc.propertyType
            }
          });
        }
      });
    }

    getProperties();
  }, [settings]);

  async function postData(id, data) {
    setIsLoading(true);
    try {
      await setDoc(doc(db, "Businesses", bid, "Leads", id), { ...data, createdAt: new Date(), updatedAt: new Date() });
      await addDoc(collection(db, "Businesses", bid, "Leads", id, "Activities"), { ...noteData, createdAt: new Date(), updatedAt: new Date() });
      setShowModal(false);
      resetForm();
      setIsLoading(false);
      toast.success("New Lead, Added.");
    } catch (error) {
      console.log('Adding Lead Data [Error] : ', error);
      setIsLoading(false);
    }
  }

  function validateAndPostData() {
    const { name, phoneNumber } = data;
    if (!name) {
      setInputError({ ...inputError, name: 'This field is required.' });
    } else if (!phoneNumber) {
      setInputError({ ...inputError, phoneNumber: 'This field is required.' });
    } else {
      setIsLoading(true);
      let uuid = uuidv4();
      postData(uuid, data);
    }
  }

  return (
    <Offcanvas
      show={showModal}
      onHide={() => {
        setShowModal(false);
        resetForm();
      }}
      backdrop="static"
      keyboard={false}
      placement='end'
      style={{ width: 700 }}
    >
      <div className='offcanvas-header py-4 border-bottom'>
        <h5 className='mb-0'>Add New Lead</h5>
        <Button
          variant='none'
          className='btn-close px-3'
          onClick={() => {
            setShowModal(false);
            resetForm();
          }}
        />
      </div>
      <div className='modal-body p-0'>
        <div className='px-4 mb-3'>
          <LeadForm
            data={data}
            setData={setData}
            noteData={noteData}
            setNoteData={setNoteData}
            properties={properties}
            states={statesCities && statesCities}
            cities={cities}
            getCityByState={getCityByState}
            countries={countries}
            inputError={inputError}
            setInputError={setInputError}
          />
        </div>
      </div>
      <div className='modal-footer px-3 py-3 border-top align-items-center justify-content-between'>
        <Button
          variant="outline-danger"
          onClick={() => {
            setShowModal(false);
            resetForm();
          }}
          className='px-5 py-2'
        >
          Cancel
        </Button>
        {
          isLoading ?
            <Button
              disabled
              variant="primary"
              className='px-5 py-2 btn-width'
              onClick={() => null}
            >
              <Spinner />
            </Button>
            :
            <Button
              variant="primary"
              className='px-5 py-2 btn-width'
              onClick={() => validateAndPostData()}
            >
              Save
            </Button>
        }
      </div>
    </Offcanvas>
  );
}

export default AddNewLead;